import { useAuth } from '@pooflabs/web';
import { ADMIN_ADDRESS } from '@/lib/constants';
import type { AuthContextType } from '@/components/types';

/**
 * Returns true when the currently authenticated user is the project admin
 * (i.e. their wallet address matches ADMIN_ADDRESS from constants.ts).
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth() as AuthContextType;
  return user?.address === ADMIN_ADDRESS;
}
